import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_1.jpg';
import projectImage2 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_6.jpg';

import Data_norcatLockTag from './Data_NORCATLockTag';

function Work_norcatLockTag() {
    return (
        <>
            <DetailedHeader
                heading="Where Lockout Procedures Become Second Nature"
                client="NORCAT"
                service="Virtual Reality"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=lD-et4T-N0c"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_norcatLockTag.content}
        </>
    );
}

export default Work_norcatLockTag;
